module.exports = __webpack_public_path__ + "img/fra.5427ba88.png";